<template>
  <div>
    <b-modal id="modalEditIPzones" ref="modalEditIPzones" :title="$t('IP zone')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.id">
            <b-form-input type="text" v-model="editItem.id" disabled/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editItem.name"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Subnets')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="showModalSubnets">{{ $t('Add') }}</b-button>
          </b-form-group>
          <b-table striped hover small
            :items="editItem.networks"
            :fields="subnetsFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnDeleteSubnetButton(row)" id="transparent">
                <b-img :src='deleteImage'/>
              </b-button>
          </template>
          </b-table>
          <b-row>
            <b-col>
              <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
            </b-col>
            <b-col sm="1.5">
              <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$refs.modalEditIPzones.hide">{{ $t('Cancel') }}</b-button>
            </b-col>
          </b-row>
      </div>
    </b-modal>

    <b-modal hide-footer ref="modalSubnetsReferenceBook" id="modalSubnetsReferenceBook" :title="$t('Subnets')">
      <b-form-group label-align="right" :label="$t('Network')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newSubnets.network"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Gateway')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newSubnets.gateway"/>
      </b-form-group>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addSubnest">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$bvModal.hide('modalSubnetsReferenceBook')">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      deleteImage: require('@/assets/img/document_delete.png'),
      newSubnets: {
        'gateway': '0.0.0.0',
        'network': '0.0.0.0',
        'mask': ''
      },
      subnetsFields: [
        {key: 'network', label: this.$i18n.t('Network'), sortable: true},
        {key: 'gateway', label: this.$i18n.t('Gateway'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    addSubnest () {
      if (this.newSubnets.network.includes(':')) {
        if (!this.validationIPv6()) {
          return
        }
        if (!this.validationGatewayv6()) {
          return
        }
        this.newSubnets.mask = Number(this.newSubnets.network.split('/')[1])
        this.newSubnets.network = this.newSubnets.network.split('/')[0]
        if (!Number(this.newSubnets.mask)) {
          this.newSubnets.mask = 128
        }
      } else {
        if (!this.validationIPv4()) {
          return
        }
        if (!this.validationGatewayv4()) {
          return
        }
        this.newSubnets.mask = Number(this.newSubnets.network.split('/')[1])
        this.newSubnets.network = this.newSubnets.network.split('/')[0]
        if (!Number(this.newSubnets.mask)) {
          this.newSubnets.mask = 32
        }
      }
      this.editItem.networks.push(this.newSubnets)
      this.$refs.modalSubnetsReferenceBook.hide()
    },
    validationIPv4 () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newSubnets.network.split('/')[0].match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationGatewayv4 () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newSubnets.gateway.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect gateway format'), 'Error')
        return false
      }
    },
    validationIPv6 () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (this.newSubnets.network.split('/')[0].match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationGatewayv6 () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      if (this.newSubnets.gateway.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect gateway format'), 'Error')
        return false
      }
    },
    ClickOnDeleteSubnetButton (row) {
      this.editItem.networks = this.editItem.networks.filter((value) => {
        return value !== row.item
      })
    },
    showModalSubnets () {
      this.newSubnets = {
        'gateway': '0.0.0.0',
        'network': '0.0.0.0',
        'mask': ''
      }
      this.$refs.modalSubnetsReferenceBook.show()
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Name'), 'Error')
        return
      }
      if (this.editItem.networks <= 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Subnets table is empty'), 'Error')
        return
      }

      for (let el of this.editItem.networks) {
        el.mask = el.mask_dec
      }
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('ReferenceBooks/UPDATE_IP_ZONES', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_IP_ZONES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_IP_ZONES')
          this.$refs.modalEditIPzones.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/IPzone/editModal.vue